import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Dateable } from 'pkg/api/models/dateable';
import type { Record } from 'pkg/api/models/record';

export enum UserGoalCategories {
	General = 'general',
	Mental = 'mental',
	Physical = 'physical',
	Social = 'social',
	Tactical = 'tactical',
	Technical = 'technical',
}

export interface UserGoal extends Record, Dateable, AllowedActionable {
	name: string;

	completedAt?: number;
	userId: number;
	accountId: number;

	category: UserGoalCategories;
	description: string;
	goal: string;
	progress: number;
}
